import { useEffect } from "react";

import { Box, CircularProgress, Typography } from "@mui/material";

import nylasApi from "../api/nylas.api";

/**
 * NylasCallback Component
 *
 * This component should only be opened in a popup window.
 *
 *
 * This component handles the callback from the Nylas authentication process.
 * It reads the authorization code from the URL query parameters, exchanges it
 * for a mailbox token using the Nylas API. If this component is opened as a popup, it
 * will trigger a user data refresh in the parent window and close itself.
 *
 * @component
 * @example
 * return (
 *   <NylasCallback />
 * )
 */
function NylasCallback() {
  useEffect(() => {
    // Handle the code that is passed in the query params from Nylas after a successful login
    const parameters = new URLSearchParams(globalThis.location.search);
    if (parameters.has("code")) {
      void nylasApi.exchangeMailboxToken(parameters.get("code")).then((user) => {
        if (window.opener && window.opener.updateUserData) {
          window.opener.handlePopups();
          window.opener.updateUserData(user);
          window.close();
        }
      });
    }
  });

  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        gap: 2,
        height: "100vh",
        justifyContent: "center",
        width: "100vw",
      }}
    >
      <CircularProgress color="primary" size={80} />
      <Typography variant="h5">Authenticating Email...</Typography>
    </Box>
  );
}

export default NylasCallback;
